export const userType = {
  CRIACAO_CONTEUDO: "Criação de Conteúdo",
  CORRECAO_ORTOGRAFICA: "Correção Ortográfica",
  SUPERVISOR: "Supervisor"
};
